import http from '@/shared/api/http'

export async function getAllDiscounts() {
  return (await http.get('discounts')).data
}

export async function createDiscount(data) {
  return (await http.post('discounts', data)).data
}

export async function updateDiscount(id, data) {
  return (await http.put(`discounts/${id}`, data)).data
}

export async function deleteDiscount(id) {
  return (await http.delete(`discounts/${id}`)).data
}